export default (value) => {
   const dateC = new Date(value)
   return dateC.toLocaleString(['es-ES'], {month: 'long',
    day: '2-digit', year: 'numeric'})
}                                                                                                                                           


// WEBPACK FOOTER //
// ./src/filtros/fechaCompleta.js